import { IExtraArgument, IGcpAppDispatch } from "../../../redux/store";
import { getGeolocationState, IStoreState } from "../../../redux/rootReducer";
import {
  STATE_CHASING,
  STATE_ERROR,
  STATE_INACTIVE,
  STATE_WATCHING,
} from "../../../redux/modules/geolocation/reducer";
import {
  startGeolocationChasing,
  startGeolocationWatching,
  stopGeolocation,
} from "../../../redux/modules/geolocation/asyncActions";
import { IPlainError } from "../../../error/toPlainError";
import {
  GEOLOCATION_IS_DISABLED,
  GEOLOCATION_IS_ENABLED,
} from "../../../tracking/constants";

const GEOLOCATION_ERROR_CODE_PERMISSION_DENIED = 1;

const geolocationErrorToMessage = (error: IPlainError) =>
  error.code === `${GEOLOCATION_ERROR_CODE_PERMISSION_DENIED}`
    ? [
        "TraceAir does not have permission to access your location. \n",
        "Please allow access and refresh the page.",
        "You may need to modify the privacy settings for your browser.",
      ].join(" ")
    : error.message;

export const userClicksGeolocationButton =
  () =>
  async (
    dispatch: IGcpAppDispatch,
    getState: () => IStoreState,
    { alert, trackAction }: IExtraArgument,
  ) => {
    const handleGeolocationError = (
      positionError: GeolocationPositionError,
    ) => {
      alert(
        geolocationErrorToMessage({
          code: `${positionError.code}`,
          message: positionError.message,
        }),
      );
    };
    const { stateStatus, error } = getGeolocationState(getState());
    switch (stateStatus) {
      case STATE_INACTIVE:
        trackAction(GEOLOCATION_IS_ENABLED);
        return dispatch(startGeolocationChasing(handleGeolocationError));
      case STATE_CHASING:
        trackAction(GEOLOCATION_IS_DISABLED);
        return dispatch(stopGeolocation());
      case STATE_WATCHING:
        trackAction(GEOLOCATION_IS_ENABLED);
        return dispatch(startGeolocationChasing(handleGeolocationError));
      case STATE_ERROR:
        return alert(geolocationErrorToMessage(error));
      default:
        return;
    }
  };

export const userDragsMap =
  () =>
  async (
    dispatch: IGcpAppDispatch,
    getState: () => IStoreState,
    { alert }: IExtraArgument,
  ) => {
    const geolocationState = getGeolocationState(getState());
    if (geolocationState.stateStatus === STATE_CHASING) {
      return dispatch(
        startGeolocationWatching((error: GeolocationPositionError) => {
          alert(
            geolocationErrorToMessage({
              code: `${error.code}`,
              message: error.message,
            }),
          );
        }),
      );
    }
  };
